'use strict';

angular.module('shiftTraderApp')
  .directive('saPermissionRequired', function ($animate, UserPermissionsService, $q, $interpolate, $parse) {
    // this directive CAN be used with ngIf on the sade node
    // ngIf will evaluate its condition, then this link function executes
    // we do NOT use terminal: true here, as ngIf is terminal

    return {
      transclude: 'element',
      priority: 599, // one below ngIf (600)
      restrict: 'A',
      //terminal: true,

      link: function ($scope, $element, $attr, ctrl, $transclude) {
        var block, childScope, previousElements, hasPermission, orgId;

        var orgIdObserverDereg = $attr.$observe('organizationId', function(value) {
          console.log('organizationId: ', $attr.organizationId, value, $interpolate(value)($scope));

          if (value === 'current') {
            orgId = 'current';
            orgIdObserverDereg();
            kickOffPermissionCheck()
          } else {
            // try interpolating it...
            var interp = parseInt($interpolate(value)($scope));

            if (!_.isNaN(interp) && interp !== Infinity && interp !== -Infinity) {
              orgId = interp;
              orgIdObserverDereg();
              kickOffPermissionCheck()
            }
          }
        });


        function kickOffPermissionCheck() {
          var permissionString = $attr.saPermissionRequired;
          var useAll = $attr.all === 'all';

          console.log('kicking off checks: ', permissionString, orgId);

          var permissionNames = _.map(permissionString.split(','), function(x) {
            return x.trim();
          });

          var promises = _.map(permissionNames, function(permission) {
            return UserPermissionsService.can(permission, orgId);
          });

          $q.all(promises)
            .then(function(results) {
              if (useAll) {
                hasPermission = _.all(results, function(x) {return x; });
              } else {
                hasPermission = _.any(results, function(x) {return x; });
              }
              render();
            });
        }

        function render() {
          if (hasPermission) {
            if (!childScope) {
              $transclude(function(clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = document.createComment(' end saPermissionRequired: ' + $attr.saPermissionRequired + ' ');
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };

                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }

            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }

            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).then(function() {
                previousElements = null;
              });
              block = null;
            }
          }
        }
      }
    };
  });
